export default __webpack_public_path__ + "static/media/bow.b86f7f4f.png";